module.exports = __webpack_public_path__ + "fonts/9a3bc98d463db85bbd21bc4e8913749b.eot";